import { render } from "./TheConfirmationDialog.vue?vue&type=template&id=c0326d9c&ts=true"
import script from "./TheConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./TheConfirmationDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__